import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import * as moment from "moment";
import "moment-timezone";
import {
  deleteUserById,
  userList,
  bookingList,
  sendMail,
  getBookingRequestDetailsById,
  getFlightDownloadFiltered,
  getFlightDownloadTicket,
} from "../../../services/userservice";
import {
  setLoading as setBookingLoading,
  setBookings,
  setError,
} from "../../../features/common/bookingSlice";
import { Button, Modal } from "react-bootstrap";
import "./css/booking-detail.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const FlightBookings = () => {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [bookingsPerPage] = useState(25);
  const [searchTerm, setSearchTerm] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [showToaster, setShowToaster] = useState(false);
  const { bookings, loading, error } = useSelector((state) => state.booking);
  const [showModal, setShowModal] = useState(false);
  const [showMailModal, setShowMailModal] = useState(false);
  const handleCloseModal = () => setShowModal(false);
  const [showLogModal, setShowLogModal] = useState(false);
  const handleViewCloseModal = () => setShowLogModal(false);
  const navigate = useNavigate();
  const [selectedBookingId, setBookingId] = useState(null);
  const [requestData, setRequestData] = useState();
  const [searchTerms, setSearchTerms] = useState("");
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [status, setStatus] = useState("");
  const [paymentstatus, setPaymentStatus] = useState("");
  const [result, setResult] = useState(null);
  const [isAutoFetchActive, setIsAutoFetchActive] = useState(true);
  const [downloadTicket, setDownloadTicket] = useState(false);
  const dispatch = useDispatch();
  const intervalRef = useRef(null);
  const userType = JSON.parse(localStorage.getItem("user"));

  // console.log("fromDate", userType?.user_type)

  useEffect(() => {
    const fetchBookingData = async () => {
      try {
        const response = await bookingList();
        dispatch(setBookings(response));
      } catch (error) {
        dispatch(setError(error.message));
      }
    };

    if (isAutoFetchActive) {
      fetchBookingData(); // initial call
      intervalRef.current = setInterval(fetchBookingData, 10000); // every 10 sec
    }

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current); // clean up
    };
  }, [dispatch, isAutoFetchActive]);

  const handleSendMail = async (id) => {
    try {
      const response = await sendMail(id);
      if (response.data) {
        setShowMailModal(true);
        setShowModal(false);
        setTimeout(() => {
          navigate("/flight-bookings");
          setShowMailModal(false);
          setShowModal(false);
        }, 2000);
      }

      // alert(response.data);
    } catch (error) {
      console.error("Error sending email:", error);
      alert("Failed to send email");
    }
  };

  const viewLogResponse = async (id, type) => {
    try {
      const response = await getBookingRequestDetailsById(id, type);
      if (response) {
        setRequestData(response);
        setShowLogModal(true);
      }

      // alert(response.data);
    } catch (error) {
      console.log("pk", error.message);
      console.error("Error pankaj email:", error);
    }
  };

  const openModal = (bookingId) => {
    setBookingId(bookingId);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  if (loading) return <div>Loading...</div>; // Render a loading message

  if (error) return <div>Error: {error}</div>; // Render an error message

  const filteredbookings = bookings.filter(
    (booking) =>
      //  booking.smt_booking_id
      booking?.smt_booking_id
        ?.toLowerCase()
        .includes(searchTerm.toLowerCase()) ||
      booking.billing_email.toLowerCase().includes(searchTerm.toLowerCase()) ||
      booking.billing_email.toLowerCase().includes(searchTerm.toLowerCase()) ||
      booking.passengers.some((passenger) =>
      passenger.first_name.toLowerCase().includes(searchTerm.toLowerCase())
      ) ||
      booking.passengers.some((passenger) =>
      passenger.last_name.toLowerCase().includes(searchTerm.toLowerCase())
      ) ||
        booking.travelInfos.some((travel_info) =>
      travel_info?.pnr_number?.toLowerCase().includes(searchTerm.toLowerCase())
      )
    //   booking.billing_email.toLowerCase().includes(searchTerm.toLowerCase()) ||
    //   booking.departure_city.toLowerCase().includes(searchTerm.toLowerCase()) ||
    //   booking.arrival_city.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const handleFromDateChange = (date) => {
    setFromDate(date);
    if (date && toDate && date > toDate) {
      setToDate(null);
    }
  };

  const handleToDateChange = (date) => {
    setToDate(date);
  };

  const formatDateToYMD = (date) => {
    if (!date) return "";
    const year = date.getFullYear();
    const month = `0${date.getMonth() + 1}`.slice(-2);
    const day = `0${date.getDate()}`.slice(-2);
    return `${year}-${month}-${day}`;
  };

  // const handleApplyFilter = async () => {
  //   try {
  //     const formattedFromDate = formatDateToYMD(fromDate);
  //     const formattedToDate = formatDateToYMD(toDate);
  //     const formattedStatus = status.toLowerCase();
  //     const formattedPaymentStatus = paymentstatus.toLowerCase();

  //     const data = await getFlightDownloadFiltered(
  //       formattedFromDate,
  //       formattedToDate,
  //       formattedStatus,
  //       paymentstatus
  //     );
  //     console.log("Filtered Data:", data);
  //     dispatch(setBookings(data));
  //     setDownloadTicket(true);
  //     setIsAutoFetchActive(false);
  //   } catch (error) {
  //     console.error("Error fetching filtered data:", error);
  //   }
  // };

  const handleApplyFilter = async () => {
  try {
    const formattedFromDate = formatDateToYMD(fromDate);
    const formattedToDate = formatDateToYMD(toDate);

    const formattedStatus = status ? status.toLowerCase() : "";
    const formattedPaymentStatus = paymentstatus
      ? paymentstatus.toLowerCase()
      : "";

    const data = await getFlightDownloadFiltered(
      formattedFromDate,
      formattedToDate,
      formattedStatus,
      formattedPaymentStatus
    );

    console.log("Filtered Data:", data);

    dispatch(setBookings(data));
    setDownloadTicket(true);
    setIsAutoFetchActive(false);
  } catch (error) {
    console.error("Error fetching filtered data:", error);
  }
};

  const handleResetFilter = async () => {
    try {
      setIsAutoFetchActive(true);
      setFromDate(null);
      setToDate(null);
      setDownloadTicket(false);
      setStatus("");
      setPaymentStatus("");
    } catch (error) {
      console.error("Error resetting filter:", error);
    }
  };

  const onClickdownloadTicket = async () => {
  try {

    const formattedFromDate = fromDate
      ? moment(fromDate).format("YYYY-MM-DD")
      : "";

    const formattedToDate = toDate
      ? moment(toDate).format("YYYY-MM-DD")
      : "";

    const formattedStatus = status ? status.toLowerCase() : "";
    const formattedPaymentStatus = paymentstatus
      ? paymentstatus.toLowerCase()
      : "";

    const response = await getFlightDownloadTicket(
      formattedFromDate,
      formattedToDate,
      formattedStatus,
      formattedPaymentStatus
    );

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = "flight_bookings.xlsx";

    document.body.appendChild(link);
    link.click();
    link.remove();

    window.URL.revokeObjectURL(url);

  } catch (error) {
    console.error("Error downloading the ticket:", error);
  }
};
  // const onClickdownloadTicket = async () => {
  //   try {
  //     const formattedFromDate = moment(fromDate).format('YYYY-MM-DD');
  //     const formattedToDate = moment(toDate).format('YYYY-MM-DD');
  //     const fileData = await getFlightDownloadTicket(
  //       formattedFromDate,
  //       formattedToDate,
  //       status,
  //       paymentstatus
  //     );
  //     const blob = new Blob([fileData], {
  //       type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //     });
  //     const link = document.createElement("a");
  //     const urlObject = URL.createObjectURL(blob);
  //     link.href = urlObject;
  //     link.download = "flight_bookings.xlsx";
  //     link.click();
  //     URL.revokeObjectURL(urlObject);
  //   } catch (error) {
  //     console.error("Error downloading the ticket:", error);
  //     alert("There was an error downloading the ticket");
  //   }
  // };

  // Table rows to show per page Start

  const indexOfLastBooking = currentPage * rowsPerPage;
  const indexOfFirstBooking = indexOfLastBooking - rowsPerPage;
  const currentBookings = filteredbookings.slice(
    indexOfFirstBooking,
    indexOfLastBooking
  );

  // bottom pagination start

  const totalPages = Math.ceil(filteredbookings.length / rowsPerPage);

  const renderPageNumbers = () => {
    const pages = [];
    const maxPagesToShow = 3;

    if (totalPages <= 10) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      // Always show first 3 pages
      pages.push(1, 2, 3);

      // Show "..." if currentPage is beyond 5
      if (currentPage > 5) {
        pages.push("...");
      }

      // Show current page and neighbors
      const start = Math.max(4, currentPage - 1);
      const end = Math.min(totalPages - 3, currentPage + 1);

      for (let i = start; i <= end; i++) {
        if (!pages.includes(i)) pages.push(i);
      }

      // Show "..." if currentPage is far from end
      if (currentPage < totalPages - 4) {
        pages.push("...");
      }

      // Always show last 3 pages
      pages.push(totalPages - 2, totalPages - 1, totalPages);
    }

    return pages.map((page, index) => (
      <li
        key={index}
        className={`page-item ${page === currentPage ? "active" : ""} ${
          page === "..." ? "disabled" : ""
        }`}
      >
        {page === "..." ? (
          <span className="page-link">...</span>
        ) : (
          <button className="page-link" onClick={() => setCurrentPage(page)}>
            {page}
          </button>
        )}
      </li>
    ));
  };

  return (
    <div className="content-wrapper">
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1 className="m-0">Flight Bookings</h1>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Home</Link>
                </li>
                <li className="breadcrumb-item active">Dashboard</li>
              </ol>
            </div>
          </div>
        </div>
      </div>

      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="card-header">
                  <h3 className="card-title"></h3>

                  <div className="row align-items-end">
                    {/* Search Input */}
                    <div className="col-md-3">
                      <label>Search</label>
                      <br />
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search"
                        value={searchTerm}
                        onChange={handleSearchChange}
                      />
                    </div>

                    <div className="col-md-2">
                      <label>From Date</label>
                      <br />
                      <DatePicker
                        selected={fromDate}
                        onChange={handleFromDateChange}
                        placeholderText="Select From Date"
                        dateFormat="dd/MM/yyyy"
                        className="form-control"
                        minDate={null}
                        maxDate={today}
                      />
                    </div>

                    <div className="col-md-2">
                      <label>To Date</label>
                      <br />
                      <DatePicker
                        selected={toDate}
                        onChange={handleToDateChange}
                        placeholderText="Select To Date"
                        dateFormat="dd/MM/yyyy"
                        className="form-control"
                        minDate={fromDate || today}
                        maxDate={today}
                      />
                    </div>
                    <div className="col-md-3">
                      <label>Payment Status</label>
                      <br />
                      <select
                        className="form-control"
                        value={paymentstatus}
                        onChange={(e) => setPaymentStatus(e.target.value)}
                      >
                        <option value="">Select Payment Status</option>
                        <option value="SUCCESS">Success</option>
                        <option value="FAILED">Failed</option>
                        <option value="PENDING">Pending</option>
                        <option value="PARTIAL_CHARGED">Partial Charged</option>
                        <option value="AUTHENTICATION_FAILED">
                          Authentication Failed
                        </option>
                        <option value="AUTHORIZATION_FAILED">
                          Authorization Failed
                        </option>
                        <option value="AUTHORIZING">Authorizing</option>
                        <option value="STARTED">Started</option>
                        <option value="AUTO_REFUNDED">Auto Refunded</option>
                      </select>
                    </div>

                    <div className="col-md-2">
                      <label>Booking Status</label>
                      <br />
                      <select
                        className="form-control"
                        value={status}
                        onChange={(e) => setStatus(e.target.value)}
                      >
                        <option value="">Select Status</option>
                        <option value="pending">Pending</option>
                        <option value="success">Success</option>
                        <option value="failed">Failed</option>
                      </select>
                    </div>
                  </div>
                  <div className="d-flex justify-content-end">
                    <button
                      className="btn btn-primary mt-3 mx-2"
                      onClick={handleApplyFilter}
                    >
                      Apply Filter
                    </button>
                    {downloadTicket && (
                      <button
                        className="btn btn-primary mt-3 mx-2"
                        onClick={handleResetFilter}
                      >
                        Reset Filter
                      </button>
                    )}
                    {downloadTicket &&
                        <button
                          className="btn btn-primary mt-3"
                          onClick={onClickdownloadTicket}
                        >
                          Download ({filteredbookings.length})
                        </button>
                      }
                  </div>
                </div>

                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <div>
                      <label className="me-2">Show</label>
                      <select
                        value={rowsPerPage}
                        onChange={(e) => {
                          setRowsPerPage(parseInt(e.target.value));
                          setCurrentPage(1); // Reset to first page
                        }}
                        className="form-control mx-2 form-select d-inline-block w-auto"
                      >
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                      </select>
                      <span className="ms-2">entries</span>
                    </div>
                    <div>
                      {/* Optional: Add search or pagination controls here */}
                    </div>
                  </div>

                  <div className="table-responsive">
                    <table
                      className="table table-bordered table-hover"
                    >
                      <thead>
                        <tr>
                          <th style={{ width: "250px" }}>Booking ID</th>
                          <th style={{ width: "100px" }}>Device</th>
                          <th style={{ width: "300px" }}>Name</th>
                          {userType?.user_type !== "SEO" && (
                            <>
                              <th style={{ width: "300px" }}>Email</th>
                            </>
                          )}
                          <th style={{ width: "175px" }}>Booking Date</th>
                          <th style={{ width: "150px" }}>Departure</th>
                          <th style={{ width: "150px" }}>Arrival</th>
                          <th style={{ width: "120px" }}>Payment</th>
                          <th style={{ width: "120px" }}>Booking</th>
                          <th style={{ width: "100px" }}>Vendor</th>
                          {userType?.user_type !== "SEO" && (
                            <th style={{ width: "160px" }}>Action</th>
                          )}
                        </tr>
                      </thead>
                      {filteredbookings.length > 0 ? (
                        <tbody>
                          {currentBookings.map((booking) => (
                            <tr
                              key={booking.id}
                              style={
                                moment().diff(
                                  moment(booking?.createdAt),
                                  "hours"
                                ) < 24
                                  ? {
                                      fontWeight: "bolder",
                                      backgroundColor: "#0c16d84f",
                                    }
                                  : {}
                              }
                            >
                              {/* <td>{booking?.smt_booking_id} </td> */}
                              <td>
                                <Link to={`/booking-detail/${booking.id}`}>
                                  <span className="mx-3">
                                    {booking?.smt_booking_id}
                                  </span>
                                  {moment().diff(
                                    moment(booking?.createdAt),
                                    "hours"
                                  ) < 24 && (
                                    <span className="right badge badge-danger">
                                      New
                                    </span>
                                  )}
                                </Link>
                              </td>
                              <td>
                                {booking?.device_type === 1
                                  ? "Web"
                                  : booking?.device_type === 2
                                  ? "App"
                                  : booking?.device_type === 3
                                  ? "Mobile"
                                  : "Unknown"}
                              </td>
                              <td>
                                    {booking?.passengers[0]?.first_name +
                                      " " +
                                      booking?.passengers[0]?.last_name}
                                  </td>
                              {userType?.user_type !== "SEO" && (
                                <>
                                 

                                  <td>{booking?.billing_email}</td>
                                </>
                              )}

                              <td>
                                {/* {new Date("2025-03-11T12:19:29.668Z").toLocaleString()} */}
                                {moment(booking?.booking_date).format(
                                  "DD-MM-YY hh:mm A"
                                )}
                                {/* {moment.utc(booking?.createdAt).tz("Asia/Kolkata").format("DD-MM-YY hh:mm A")} */}
                              </td>
                              <td>{booking?.origin}</td>
                              <td>{booking?.destination}</td>

                              <td>
                                <span
                                  className={`badge p-2 w-100 ${
                                    booking.payment_status === "SUCCESS"
                                      ? "badge-success"
                                      : booking.payment_status === "FAILED"
                                      ? "badge-danger"
                                      : "badge-warning"
                                  }`}
                                >
                                  {booking.payment_status.toUpperCase()}
                                </span>
                              </td>
                              <td>
                                <span
                                  className={`badge p-2 w-100 ${
                                    booking.booking_status === "SUCCESS"
                                      ? "badge-success"
                                      : booking.booking_status === "FAILED"
                                      ? "badge-danger"
                                      : "badge-warning"
                                  }`}
                                >
                                  {booking.booking_status.toUpperCase()}
                                </span>
                              </td>
                              <td>{booking?.vendor_type?.toUpperCase()}</td>
                              {userType?.user_type !== "SEO" && (
                                <td>
                                  <Link to={`/booking-detail/${booking.id}`}>
                                    <button className="btn btn-primary btn-sm">
                                      <i class="fa fa-eye"></i>
                                    </button>
                                  </Link>
                                  &nbsp;
                                  {(booking?.payment_status === "CHARGED" ||
                                    booking?.payment_status === "SUCCESS") && (
                                    <button
                                      className="btn btn-primary btn-sm"
                                      onClick={() => openModal(booking?.id)}
                                      //  onClick={() => handleSendMail(booking.id)}
                                    >
                                      <i className="fa fa-envelope"></i>
                                    </button>
                                  )}
                                  &nbsp;
                                  <button
                                    className="btn btn-primary btn-sm"
                                    onClick={() =>
                                      viewLogResponse(booking?.id, 5)
                                    }
                                    //  onClick={() => handleSendMail(booking.id)}
                                  >
                                    <i className="fa fa-dollar-sign"></i>
                                  </button>
                                  &nbsp;
                                  {(booking?.payment_status === "CHARGED" ||
                                    booking?.payment_status === "SUCCESS") && (
                                    <button
                                      className="btn btn-primary btn-sm"
                                      onClick={() =>
                                        viewLogResponse(booking?.id, 2)
                                      }
                                      //  onClick={() => handleSendMail(booking.id)}
                                    >
                                      <i className="fa fa-plane"></i>
                                    </button>
                                  )}
                                </td>
                              )}
                            </tr>
                          ))}
                        </tbody>
                      ) : (
                        <div className="text-center p-3">
                          <h5 style={{ color: "red", textAlign: "center" }}>
                            No bookings found
                          </h5>
                        </div>
                      )}
                    </table>
                  </div>

                  <div className="d-md-flex justify-content-between align-items-center mt-3">
                    <div>
                      Showing {indexOfFirstBooking + 1} to{" "}
                      {Math.min(indexOfLastBooking, filteredbookings.length)} of{" "}
                      {filteredbookings.length} entries
                    </div>
                    <nav>
                      <ul className="pagination mb-0">
                        <li
                          className={`page-item ${
                            currentPage === 1 ? "disabled" : ""
                          }`}
                        >
                          <button
                            className="page-link"
                            onClick={() => setCurrentPage(currentPage - 1)}
                          >
                            Previous
                          </button>
                        </li>

                        {renderPageNumbers()}

                        <li
                          className={`page-item ${
                            currentPage === totalPages ? "disabled" : ""
                          }`}
                        >
                          <button
                            className="page-link"
                            onClick={() => setCurrentPage(currentPage + 1)}
                          >
                            Next
                          </button>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Modal show={showMailModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>
            <i className="fa fa-check-circle text-success"></i>
            Success
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="text-center">
            <i
              className="fa fa-check-circle text-success mb-4"
              style={{ fontSize: "4rem" }}
            ></i>
            <h4>Mail has been successfully sent!</h4>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showModal} onHide={closeModal}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="text-center p-4">
            <h5>Are you sure you want to send this mail?</h5>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-secondary" onClick={closeModal}>
            Cancel
          </button>
          <button
            className="btn btn-danger"
            onClick={() => handleSendMail(selectedBookingId)}
          >
            OK
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showLogModal}
        onHide={handleViewCloseModal}
        centered
        size="lg"
        className="custom-enquiry-modal"
      >
        <Modal.Header>
          <Modal.Title className="d-flex align-items-center">
            <i
              className="fa fa-envelope-open-text text-primary mx-2"
              style={{ color: "#fff" }}
            ></i>
            Log Details
          </Modal.Title>
          <i
            className="fa fa-times close-icon"
            onClick={handleViewCloseModal}
            role="button"
            aria-label="Close Modal"
            title="Close"
          ></i>
        </Modal.Header>
        <Modal.Body className="p-0">
          <div className="modal-body-wrapper">
            <div className="enquiry-section">
              <h5 className="section-title">Request</h5>
              <br />
              <pre style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                <code>{JSON.stringify(requestData?.request, null, 2)}</code>
              </pre>
            </div>
            <div className="enquiry-section">
              <h5 className="section-title">Response Data</h5> <br />
              <pre style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                <code>{JSON.stringify(requestData?.response, null, 2)}</code>
              </pre>
            </div>
            <div className="enquiry-section">
              <h5 className="section-title">Timestamps</h5>
              <p>
                <strong>Created At:</strong>{" "}
                {moment
                  .utc(requestData?.created_at)
                  .tz("Asia/Kolkata")
                  .format("LLLL") ?? "N/A"}
              </p>
              <p>
                <strong>Updated At:</strong>{" "}
                {moment
                  .utc(requestData?.updated_at)
                  .tz("Asia/Kolkata")
                  .format("LLLL") ?? "N/A"}
              </p>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-center">
          <Button variant="primary" onClick={handleViewCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default FlightBookings;
